// Copyright (c) 2025 TrustCloud Corporation - All rights reserved.
//
// This software contains valuable confidential and proprietary information of
// TrustCloud Corporation
//
// Unauthorized use, reproduction, transmission, or distribution of this file and its
// contents is a violation of applicable law.
import styled from '@emotion/styled';

export const AchievementContainer = styled.div`
  display: flex;
  gap: 48px;

  & > div {
    display: flex;
    flex-direction: column;
    gap: 12px;
  }
`;
